export default __webpack_public_path__ + "static/media/calendar-updates.44235c51.svg";